var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2A35",
    d: "M12 1.44C6.168 1.44 1.44 6.168 1.44 12c0 5.294 3.9 9.666 8.982 10.43v-7.631H7.809v-2.776h2.613v-1.847c0-3.058 1.49-4.4 4.031-4.4 1.218 0 1.861.09 2.166.13V8.33h-1.734c-1.079 0-1.456 1.023-1.456 2.176v1.517h3.163l-.43 2.776H13.43v7.653c5.155-.7 9.131-5.106 9.131-10.452 0-5.832-4.728-10.56-10.56-10.56Z",
    opacity: 0.4
  })));
};
export default SvgFacebook;